import createIndexedDb from "../db.js";
import Dexie from "dexie";

const getCloseCashboxes = async (shopCode) => {
  const db = createIndexedDb(shopCode);
  if (!db) return [];
  return await db.cashboxReports.toArray();
};

const insertCloseCashbox = async (shopCode, closeCashbox) => {
  const db = createIndexedDb(shopCode);
  if (!db) return null;
  const closeCashboxId = await db.cashboxReports.add(closeCashbox);
  return { id: closeCashboxId, ...closeCashbox }
};

const updateCloseCashbox = async (shopCode, closeCashbox) => {
  const db = createIndexedDb(shopCode);
  if (!db) return;
  const cloneCloseCashbox = Dexie.deepClone(closeCashbox);
  await db.cashboxReports.put(cloneCloseCashbox);
};

const deleteCloseCashbox = async (shopCode, closeCashbox) => {
  const db = createIndexedDb(shopCode);
  if (!db) return;
  await db.cashboxReports.delete(closeCashbox.id);
};


export default {
  getCloseCashboxes,
  insertCloseCashbox,
  updateCloseCashbox,
  deleteCloseCashbox,
};
